"use client";

import React from "react";
import { cn } from "@/lib/utils";
import { Slot } from "@radix-ui/react-slot";

interface AddressTextProps {
  children: React.ReactNode;
  className?: string;
  asChild?: boolean;
}

/**
 * Utility wrapper to ensure wallet addresses always use the same monospace styling.
 * Use `asChild` when you want to pass the styling down to an existing element.
 * `data-private` masks the address in session replays (Sentry + Mixpanel).
 */
export const AddressText: React.FC<AddressTextProps> = ({ children, className, asChild = false }) => {
  const Component = asChild ? Slot : "span";

  return (
    <Component data-private className={cn("font-mono tracking-[0.02em]", className)}>
      {children}
    </Component>
  );
};
